<template>
  <div class="flex flex-row space-x-5">
    <template v-for="item in list" :key="item.name">
      <div class="flex flex-row items-center flex-1 bg-base-200 p-5 rounded-xl">
        <div class="flex flex-1 flex-col">
          <span class="text-sm">{{ item.name }}</span>
          <span class="text-lg font-semibold">{{ String(item.count).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</span>
        </div>
        <div :class="[item.iconColor, 'rounded-full p-3']">
          <hero-icon v-if="item.icon" size="large" color="text-white" :name="item.icon" />
          <div v-else class="text-2xl h-7 w-7 flex items-center justify-center text-white">{{ item.iconText }}</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array
    }
  }
}
</script>
